/**
 * Featured Products Component
 * Handles AJAX add to cart functionality and cart drawer integration
 */
export default class FeaturedProducts {
  constructor(container) {
    this.container = container
    this.forms = this.container.querySelectorAll('.maybourne-featured-products__form')
    

    
    this.init()
  }
  
  init() {
    this.bindEvents()
  }
  
  bindEvents() {
    this.forms.forEach(form => {
      form.addEventListener('submit', this.handleFormSubmit.bind(this))
    })
  }
  
  async handleFormSubmit(e) {
    e.preventDefault()
    
    const form = e.target
    const formData = new FormData(form)
    const button = form.querySelector('button[type="submit"]')
    const originalText = button.textContent
    
    // Update button state
    button.textContent = 'Adding...'
    button.disabled = true
    
    try {
      // Prepare sections for cart drawer update
      const sectionsToUpdate = ['cart-drawer']
      
      // Dispatch prepare bundled sections event
      document.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: {
          sections: sectionsToUpdate
        }
      }))
      
      // Add sections parameter to formData
      formData.append('sections', sectionsToUpdate.join(','))
      
      // Add to cart using Shopify's cart API
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData)
      })
      
      if (response.ok) {
        const responseJson = await response.json()
        
        // Show success feedback
        button.textContent = 'Added!'
        
        // Get updated cart content and attach sections
        const cartContent = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json()
        cartContent['sections'] = responseJson['sections']
        
        // Dispatch events to trigger cart drawer opening
        form.dispatchEvent(new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty('items') ? responseJson['items'] : [responseJson],
            cart: cartContent,
            onSuccessDo: 'force_open_drawer'
          }
        }))
        
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            onSuccessDo: 'force_open_drawer',
            cart: cartContent
          }
        }))
        
        // Reset button after delay
        setTimeout(() => {
          button.textContent = originalText
          button.disabled = false
        }, 1500)
        
      } else {
        throw new Error('Failed to add to cart')
      }
      
    } catch (error) {
      console.error('Error adding to cart:', error)
      button.textContent = 'Error'
      setTimeout(() => {
        button.textContent = originalText
        button.disabled = false
      }, 2000)
    }
  }
  
  refresh() {
    // Re-initialize after content changes
    this.forms = this.container.querySelectorAll('.maybourne-featured-products__form')
    this.bindEvents()
  }
  
  destroy() {
    this.forms.forEach(form => {
      form.removeEventListener('submit', this.handleFormSubmit.bind(this))
    })
  }
} 